module.exports = __webpack_public_path__ + "static/media/polwear.25591045.png";